import { localStorage, sessionStorage } from 'dibs-browser-storage';

const STORAGE_KEY = 'favoriteCallout';
const CALLOUT_LIMIT = 3;

function setSessionAndStorageData(payload) {
    const { session, storage } = payload;
    localStorage.setItem(STORAGE_KEY, storage);
    sessionStorage.setItem(STORAGE_KEY, session);
}

function getSessionAndStorageData(type) {
    const storageData = localStorage.getItem(STORAGE_KEY);
    const sessionData = sessionStorage.getItem(STORAGE_KEY);
    const storage = {
        [type]: 0,
    };
    const session = {
        [type]: false,
    };

    if (storageData) {
        Object.assign(storage, storageData);
    }

    if (sessionData) {
        Object.assign(session, sessionData);
    }

    return { session, storage };
}

export function saveToStorage(payload) {
    const { type, turnOff } = payload;
    const { session, storage } = getSessionAndStorageData(type);

    storage[type]++;

    if (turnOff) {
        storage[type] = CALLOUT_LIMIT;
    }

    session[type] = true;
    setSessionAndStorageData({ session, storage });
}

export function hasSeenCallout(type) {
    const storageData = localStorage.getItem(STORAGE_KEY);
    const sessionData = sessionStorage.getItem(STORAGE_KEY);
    return (
        (sessionData && sessionData[type]) || (storageData && storageData[type] >= CALLOUT_LIMIT)
    );
}
